import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText} from "@mui/material";

const ConfirmDialog = ({ open, message, confirmLabel, cancelLabel, onAnswer, maxWidth, fullWidth }) => {

    return (
        <Dialog open={open} maxWidth={maxWidth} fullWidth={fullWidth}>
            <DialogContent>
                <DialogContentText>{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={() => onAnswer(true)}>{confirmLabel}</Button>
                <Button variant="contained" onClick={() => onAnswer(false)}>{cancelLabel}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;